<div *ngIf="connection && connection.id">
  <div id="connection-general-information">
    <div class="map-summary-item-container">
      <span class="map-summary-item-field">Name:</span>
      <span class="map-summary-item-value" [title]="connection.name">{{connection.name}}</span>
    </div>

    <div class="map-summary-item-container">
      <span class="map-summary-item-field">Weight:</span>
      <span class="map-summary-item-value" [title]="connection.weight">{{connection.weight}}</span>
    </div>

    <div class="map-summary-item-container">
      <span class="map-summary-item-field">Operative state:</span>
      <span class="map-summary-item-value" [title]="connection.operState">{{connection.operState}}</span>
    </div>

    <div class="map-summary-item-container">
      <span class="map-summary-item-field">Quality:</span>
      <span class="map-summary-item-value" [title]="connection.result">{{connection.result}}</span>
    </div>

    <div class="map-summary-item-container">
      <span class="map-summary-item-field">Transport Type:</span>
      <span class="map-summary-item-value" [title]="connection.transportType">{{connection.transportType}}</span>
    </div>

    <br/>

    <div class="map-summary-item-container">
      <span class="map-summary-item-field">Node-1:</span>
      <span class="map-summary-item-value" [title]="connection.connections[0].srcNodeName">{{connection.connections[0].srcNodeName}}</span>
    </div>


    <div class="map-summary-item-container">
      <span class="map-summary-item-field">Operative State:</span>
      <span class="map-summary-item-value" [title]="connection.connections[0].operState">{{connection.connections[0].operState}}</span>
    </div>

    <div class="map-summary-item-container">
      <span class="map-summary-item-field">Routing I/F:</span>
      <span class="map-summary-item-value" [title]="connection.connections[0].srcRoutingInterfaceName">{{connection.connections[0].srcRoutingInterfaceName}}</span>
    </div>

    <div class="map-summary-item-container">
      <span class="map-summary-item-field">Name:</span>
      <span class="map-summary-item-value" [title]="connection.connections[0].name">{{connection.connections[0].name}}</span>
    </div>

    <div class="map-summary-item-container">
      <span class="map-summary-item-field">IP Profile:</span>
      <span class="map-summary-item-value" [title]="connection.connections[0].ipProfileName">{{connection.connections[0].ipProfileName}}</span>
    </div>

    <div class="map-summary-item-container">
      <span class="map-summary-item-field">Media realm:</span>
      <span class="map-summary-item-value" [title]="connection.connections[0].mediaRealmName">{{connection.connections[0].mediaRealmName}}</span>
    </div>

    <div class="map-summary-item-container">
      <span class="map-summary-item-field">SIP Group name:</span>
      <span class="map-summary-item-value" [title]="connection.connections[0].sipGroupName">{{connection.connections[0].sipGroupName}}</span>
    </div>

    <div *ngIf="isQualityEnabled">
      <div class="map-summary-item-container">
        <span class="map-summary-item-field">Quality:</span>
        <span class="map-summary-item-value" [title]="connection.connections[0].result">{{connection.connections[0].result}}</span>
      </div>

      <div class="map-summary-item-container">
        <span class="map-summary-item-field">MOS:</span>
        <span class="map-summary-item-value"
              [title]="connection.connections[0].quality.MOS.measurement == -1 ? 'UNKNOWN' : connection.connections[0].quality.MOS.measurement">
          {{connection.connections[0].quality.MOS.measurement == -1 ? 'UNKNOWN' : connection.connections[0].quality.MOS.measurement}}
        </span>
      </div>

      <div class="map-summary-item-container">
        <span class="map-summary-item-field">ASR:</span>
        <span class="map-summary-item-value"
              [title]="connection.connections[0].quality.ASR.measurement == -1 ? 'UNKNOWN' : connection.connections[0].quality.ASR.measurement">
          {{connection.connections[0].quality.ASR.measurement == -1 ? 'UNKNOWN' : connection.connections[0].quality.ASR.measurement}}
        </span>
      </div>
    </div>

    <br/>

    <div *ngIf="connection.type !== 'NODE_TO_THIRD_PARTY' && connection.connections[1]">
      <div class="map-summary-item-container">
        <span class="map-summary-item-field">Node-2:</span>
        <span class="map-summary-item-value" [title]="connection.connections[1].srcNodeName">{{connection.connections[1].srcNodeName}}</span>
      </div>

      <div class="map-summary-item-container">
        <span class="map-summary-item-field">Operative State:</span>
        <span class="map-summary-item-value" [title]="connection.connections[1].operState">{{connection.connections[1].operState}}</span>
      </div>

      <div class="map-summary-item-container">
        <span class="map-summary-item-field">Routing I/F:</span>
        <span class="map-summary-item-value" [title]="connection.connections[1].srcRoutingInterfaceName">{{connection.connections[1].srcRoutingInterfaceName}}</span>
      </div>

      <div class="map-summary-item-container">
        <span class="map-summary-item-field">Name:</span>
        <span class="map-summary-item-value" [title]="connection.connections[1].name">{{connection.connections[1].name}}</span>
      </div>

      <div class="map-summary-item-container">
        <span class="map-summary-item-field">IP Profile:</span>
        <span class="map-summary-item-value" [title]="connection.connections[1].ipProfileName">{{connection.connections[1].ipProfileName}}</span>
      </div>

      <div class="map-summary-item-container">
        <span class="map-summary-item-field">Media realm:</span>
        <span class="map-summary-item-value" [title]="connection.connections[1].mediaRealmName">{{connection.connections[1].mediaRealmName}}</span>
      </div>

      <div class="map-summary-item-container">
        <span class="map-summary-item-field">SIP Group name:</span>
        <span class="map-summary-item-value" [title]="connection.connections[1].sipGroupName">{{connection.connections[1].sipGroupName}}</span>
      </div>

      <br/>

      <div class="map-summary-item-container">
        <span class="map-summary-item-field">Keep synchronized:</span>
        <span class="map-summary-item-value" [title]="connection.shouldSync == true ? 'YES' : 'NO'">{{connection.shouldSync == true ? 'YES' : 'NO'}}</span>
      </div>
      <br/>

      <div *ngIf="isQualityEnabled">
        <div class="map-summary-item-container">
          <span class="map-summary-item-field">Quality:</span>
          <span class="map-summary-item-value" [title]="connection.connections[1].result">{{connection.connections[1].result}}</span>
        </div>

        <div class="map-summary-item-container">
          <span class="map-summary-item-field">MOS:</span>
          <span class="map-summary-item-value" [title]="connection.connections[1].quality.MOS.measurement == -1 ? 'UNKNOWN' : connection.connections[1].quality.MOS.measurement">
            {{connection.connections[1].quality.MOS.measurement == -1 ? 'UNKNOWN' : connection.connections[1].quality.MOS.measurement}}
          </span>
        </div>

        <div class="map-summary-item-container">
          <span class="map-summary-item-field">ASR:</span>
          <span class="map-summary-item-value" [title]="connection.connections[1].quality.ASR.measurement == -1 ? 'UNKNOWN' : connection.connections[1].quality.ASR.measurement">
            {{connection.connections[1].quality.ASR.measurement == -1 ? 'UNKNOWN' : connection.connections[1].quality.ASR.measurement}}
          </span>
        </div>
      </div>
    </div>
  </div>

  <br/>

  <div id="connection-summary-charts">
    <div id="calls-chart-container">
      <div class="chart-expand-compress-buttons">
        <button class="fa fa-expand" (click)="openCallsChartDialog()"></button>
      </div>
      <div class="chart-summary-container">
        <arm-highchart [options]="optionsForCalls"></arm-highchart>
      </div>
    </div>
  </div>
</div>
